export const shouldStartRouteTopLoaderForAnchor = ({ anchor, event }: { anchor: HTMLAnchorElement; event: MouseEvent }) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return false;
    }

    if (anchor.target && anchor.target !== '_self') {
        return false;
    }

    if (anchor.hasAttribute('download')) {
        return false;
    }

    if (anchor.dataset.navigationMode === 'document') {
        return false;
    }

    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#')) {
        return false;
    }

    try {
        const url = new URL(href, window.location.href);
        const nextRouteKey = `${url.pathname}?${url.searchParams.toString()}`;
        const currentRouteKey = `${window.location.pathname}?${window.location.search.replace(/^\?/, '')}`;
        return url.origin === window.location.origin && nextRouteKey !== currentRouteKey;
    } catch {
        return false;
    }
};

export const findAnchorFromRouteClick = (event: MouseEvent) => {
    if (!(event.target instanceof Element)) {
        return null;
    }

    return event.target.closest<HTMLAnchorElement>('a[href]');
};
